<template>
	<!-- <div>
		<div class="container bg--white-mobile">
		<div class="row">
			<div class="col-12 "> -->
				<!-- <button @click="selectedFilter" data-category="All">All offers</button>
				<button @click="selectedFilter" data-category="prva">Family</button>
				<button @click="selectedFilter" data-category="druga">Couples</button>
				<button @click="selectedFilter" data-category="treca">Bussiness</button> -->

				<!-- <nav class="filters-menu"> -->
					<!-- TO DO: pozicionirati guarantee label  -->
						<!-- <p class="filters-menu__guarantee" v-html="msg.best_prices_guarantee">
						</p> -->

					<!-- <ul class="filters-menu__list filters-menu__list--center">
						<li class="filters-menu__item">
							<button @click="selectedFilter" data-category="All" class="filters-menu__link" :class="{'filters-menu__link--active':selected == 'All'}">{{msg.all_offers}}</button>
						</li>
						<li class="filters-menu__item">
							<button @click="selectedFilter" data-category="packages" class="filters-menu__link" :class="{'filters-menu__link--active':selected == 'packages'}">{{msg.packages}}</button>
						</li>
						<li class="filters-menu__item">
							<button @click="selectedFilter" data-category="offers" class="filters-menu__link" :class="{'filters-menu__link--active':selected == 'offers'}">{{msg.programmes}}</button>
						</li> -->
						<!-- <li class="filters-menu__item">
							<button @click="selectedFilter" data-category="treca" class="filters-menu__link" :class="{'filters-menu__link--active':selected == 'treca'}">Bussiness</button>
						</li> -->
					<!-- </ul>
				</nav>
			</div>
		</div>
	</div> -->
	<div class="container">
		<div class="row">
			<div class="col-12">
				<div class="swiper-container-wrap">

					
						<div :class="{'swiper-container--visible': isLoading == false}" class="swiper-container offers-block__swiper-container" ref="mySwiper">

							<div class="swiper-wrapper">
								<!-- <transition-group class="swiper-slide-animation swiper-wrapper" name="swiper-slide-animation" tag="div"> -->
								<!-- Slides -->
									<div v-for="slide in filteredItem" :key="slide.id" class="swiper-slide">
										<a :href="slide.section_friendly_path + '/' + slide.friendly_name" class="swiper-slide-card">

											<header class="swiper-slide-card__header">
												<div class="swiper-slide-card__header-title-wrap">	
													<p class="swiper-slide-card__header-overtitle">{{slide.article_aboveheadline}}</p>
													<h3 class="swiper-slide-card__header-title" v-html="slide.headline"></h3>
												</div>

												<picture>
													<!--[if IE 9]><video style="display: none;"><![endif]-->
													<source :srcset="'/en/vdatastore/image?id=' + slide.article_osnovna_slika_id + '&variation=421x421'" media="(min-width: 992px)">
													<!--[if IE 9]></video><![endif]-->
													<img class="swiper-slide-card__img lazyload" :data-src="'/en/vdatastore/image?id=' + slide.article_osnovna_slika_id + '&variation=421x421'" width="421" height="421" alt="Room">
												</picture>


												<!-- <img class="swiper-slide-card__img" :src="slide.article_osnovna_slika_url" alt> -->
											</header>

											<footer class="swiper-slide-card__footer">
												<div class="swiper-slide-card__info box-info">
													<p class="box-info__overtitle">{{slide.article_belowheadline}}</p>
													<!-- <h3 class="box-info__title">aaaa</h3> -->
													<p class="box-info__description">{{slide.custom_fields.room_size}}</p>
												</div>
												<div class="swiper-slide-card__price box-price">
													<!-- <p class="box-price__value"><strong>From</strong>{{slide.custom_fields.price}}</p> -->
													<p class="box-price__view-offer">
														{{msg.view_offer}}
													</p>
												</div>
											</footer>

										</a>
									</div>
								<!-- </transition-group> -->
							</div>

							<div class="swiper-pagination"></div>

							<div class="swiper-button-prev">
								<svg class="progress-ring" width="70" height="70">
									<circle class="progress-ring__circle progress-ring__circle--left" stroke="#ff7843" stroke-width="2" fill="transparent" r="35" cx="35" cy="35"></circle>
								</svg>
							</div>
							<div class="swiper-button-next">
								<svg class="progress-ring" width="70" height="70">
									<circle class="progress-ring__circle progress-ring__circle--right" stroke="#ff7843" stroke-width="2" fill="transparent" r="35" cx="35" cy="35"></circle>
								</svg>
							</div>
						</div>


					<transition name="fade">
						<div v-show="isLoading == true" class="swiper-loader__wrap">
							<div class="swiper-loader"></div>
							<div class="lds-dual-ring"></div>
						</div>
					</transition>

				</div>

			</div>
		</div>
	</div>

	</div>
</template>
<script>
	import Swiper from "swiper";
	import { mapState } from "vuex";

	export default {
		props: {
			offers: Object
		},
		data: () => ({
			selected: 'All',
			mySwiper: {},
			startingPosition: 0,
			isLoading: false,
			activeFilter: "All",
			
		}),
		mounted() {
			// console.log(this.offers);
			this.mySwiper = new Swiper(".offers-block .swiper-container", {
				slidesPerView: 3,
				spaceBetween: 20,
				observer: true,
				pagination: {
					el: '.offers-block .swiper-pagination',
					type: 'bullets',
					clickable: true
				},
				navigation: {
					nextEl: '.offers-block .swiper-button-next',
					prevEl: '.offers-block .swiper-button-prev',
				},
				breakpoints: {
					767: {
						slidesPerView: 1,
						spaceBetween: 15
					},
					991: {
						slidesPerView: 2,
						spaceBetween: 20
					}
				}

			});
		},
		methods: {
			selectedFilter(event) {
				
				if (!event.target.classList.contains("filters-menu__link--active") ) {
					event.preventDefault();
					this.isLoading = true;
					// this.activeFilter = event.target.textContent;
					// console.log(event.target);
					this.activeFilter = event.target.attributes["data-category"].value;
					// console.log(this.activeFilter);
					// console.log(this.$refs.mySwiper.slides, "Swiper");

					
					// this.mySwiper.slideTo(0,400,false);
					this.$data.selected = this.activeFilter;
					// simulate AJAX
					setTimeout(() => {
						this.isLoading = false;
					}, 500);

					let sliderObject = this.mySwiper;
					// console.log(sliderObject, "Swiper");

					setTimeout(() => {
						sliderObject.slideTo(0, 600);
					}, 0);

				}

			}
		},
		computed: {
			filteredItem() {
				var category = this.activeFilter;
				if (category === "All") {
					// console.log(this.offers);
					// console.log(this.offers['all_offers']);
					return this.offers['all_offers'];
				} else {
					// console.log(this.offers[category]);
					return this.offers[category];
				}
			},
			...mapState({
				msg: state => state.msg,
			})
		}

};
</script>
<style>

</style>